export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const opts = { withCredentials: true };

export const EQUIPMENT_SOURCES = [
  { key: 'van_stock', label: 'Van Stock' },
  { key: 'shop_warehouse', label: 'Shop / Warehouse' },
  { key: 'supplier_pickup', label: 'Supplier Pickup' },
  { key: 'customer_supplied', label: 'Customer Supplied' },
  { key: 'unknown', label: 'Other / Unknown' },
];
export const sourceLabel = (k) => (EQUIPMENT_SOURCES.find((s) => s.key === k) || EQUIPMENT_SOURCES[4]).label;

export const APPROVAL_META = {
  pending: { label: 'Pending Approval', cls: 'text-amber-300 bg-amber-500/15 border-amber-500/50' },
  sent_back: { label: 'Sent Back', cls: 'text-orange-300 bg-orange-500/15 border-orange-500/50' },
  rejected: { label: 'Rejected', cls: 'text-red-300 bg-red-500/15 border-red-500/50' },
  approved: { label: 'Approved', cls: 'text-emerald-300 bg-emerald-500/10 border-emerald-500/40' },
};

export const USAGE_META = {
  consumed: 'Usage recorded',
  consumed_with_shortfall: 'Usage recorded — van estimate was short',
  evidence_only: 'Install recorded — no stock change',
  no_deduction: 'Office resolved — no stock change',
  blocked: 'Usage waiting on office',
  evaluating: 'Recording usage…',
};

export const BLOCK_REASONS = {
  not_mapped: 'Not matched to a Master Inventory item yet',
  not_approved: 'Waiting for approval',
  no_van_for_technician: "Technician's van could not be identified",
  no_shop_location: 'Pick which Shop / Warehouse it came from',
  insufficient_shop_stock: 'Shop / Warehouse on-hand is lower than the installed quantity',
  possible_prior_van_transfer: 'This item was recently transferred to the tech\'s van — confirm it really came from the Shop',
  van_estimate_below_installed_qty: 'Van estimate was lower than the installed quantity (reduced to 0)',
};

export const typeLabel = (t) => String(t || 'equipment').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const ApprovalBadge = ({ status, testid }) => {
  const m = APPROVAL_META[status];
  if (!m || status === 'approved') return null;
  return <span data-testid={testid} className={`text-[9px] font-bold uppercase tracking-wider border px-1.5 py-0.5 rounded ${m.cls}`}>{m.label}</span>;
};
